import { strings } from './translations.js';

export const Errors =
{
    showAppError: (error, message) =>
    {
        let errorMessage = (error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.error &&
                            error.response.data.error.message)
                            ? error.response.data.error.message : 'Error'
        console.log(errorMessage);
        
        if (message != null && message.length > 0)
        {
            errorMessage = message;
        }
        else
        {
            if (error &&
                error.response &&
                error.response.data &&
                error.response.data.error &&
                error.response.data.error.appError)
            {
                switch (error.response.data.error.appError)
                {
                    // Users
                    case 101: errorMessage = strings('loginErrorUserNotFound'); break;
                    case 102: errorMessage = strings('userHasNoPhoneAvailable'); break;
                    case 103: errorMessage = strings('userHasNoEmailAvailable'); break;
                    case 104: errorMessage = strings('userAlreadyVerified'); break;
                    case 105: errorMessage = strings('fieldToModifyIsUsedByAnotherUser'); break;
                    case 106: errorMessage = strings('userNotLoggedIn'); break;
                    case 107: errorMessage = strings('userNotVerified'); break;
                    
                    // Verification
                    case 201: errorMessage = strings('wrongVerificationCode'); break;
                    case 202: errorMessage = strings('verificationCodeExpired'); break;
                    case 203: errorMessage = strings('verificationCodeWrongAction'); break;
                    case 204: errorMessage = strings('noVerificationCodeAvailable'); break;
                    case 205: errorMessage = strings('verificationCodeMethodUnknown'); break;
                    case 206: errorMessage = strings('dataVerifiedIncorrect'); break;
                    
                    // Devices
                    case 301: errorMessage = strings('devicesDoesNotExist'); break;
                    case 302: errorMessage = strings('deviceIdNotProvided'); break;
                    case 303: errorMessage = strings('deviceTypeNotProvided'); break;
                    case 304: errorMessage = strings('deviceNotVerified'); break;
                }
            }
        }
        return errorMessage;
    }
}